module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "bacon"
  }, [_c('div', {
    staticClass: "bacon-holder"
  }, _vm._l((3), function(x) {
    return _c('img', {
      attrs: {
        "src": require("../../assets/bacon.svg")
      }
    })
  })), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('span', {
    staticClass: "line"
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6e0b2f6a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/js/components/bacon.vue
// module id = 158
// module chunks = 0